import { Injectable, EventEmitter } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { SessionService } from '../../services/session.service';
import { HttpClient, HttpParams} from '@angular/common/http';
import { HttpParamEncoder } from '../../classes/encoder.class';
// import { Headers } from '@angular/http';

@Injectable({
  providedIn: 'root'
})
export class CatalogueService {
  public productList = new BehaviorSubject({});
  public categoryList = new BehaviorSubject([]);
  public categoryData = new BehaviorSubject({});
  public enableStaticPages= new BehaviorSubject<boolean>(null);
  cartDataChange :EventEmitter<any> =  new EventEmitter<any>();

  constructor(private api: ApiService,private sessionService: SessionService,private http: HttpClient) {
  }

  getSuperCategories(data) {
    // const headers = new Headers();
    data.date_time = (new Date()).toISOString();
    const obj = {
      'url': 'get_app_catalogue',
      'body': data,
      // 'headers': headers
    };
    return this.api.post(obj);
  }


  addRemoveFavMerchants(data) {
    // const headers = new Headers();
    const obj = {
      'url': 'merchant/addToWishlist',
      'body': data,
      // 'headers': headers
    };
    return this.api.post(obj);
  }
  getAllCategory(data, menu_id?) {
    // const headers = new Headers();
    // if (!data.date_time) {
    //   data.date_time = (new Date()).toISOString();
    // }
    const obj = {
      // 'url': 'get_app_catalogue',
      'url': 'catalogue/get',
      'body': {
        ...(data || {}), // Safely spread data if it exists, otherwise spread an empty object
        menu_id // Add the new `menu_id` property
      }
      // 'headers': headers
    };
    return this.api.post(obj);
  }
  getProduct(data, menu_id?) {
    if(this.sessionService.get('config').is_deliverect_enabled && this.sessionService.get('stores') && this.sessionService.get('stores')[0] && this.sessionService.get('stores')[0].additional_fields && this.sessionService.get('stores')[0].additional_fields.merchant_deliverect_enabled) {
      const deliveractData = {
        'offset': data.offset,
        'limit': data.limit,
        'marketplace_reference_id': data.marketplace_reference_id,
        'marketplace_user_id': data.marketplace_user_id,
        'user_id': data.user_id,
        'date_time': data.date_time
      }
      if(data.parent_category_id) {
        const deliveractObj = {
          'url':'v3/catalogue/'+ data.parent_category_id  +'/products',
          'body': deliveractData,
        };
        return this.api.getWithoutPostToGet(deliveractObj);
      }
      else {
        const deliveractObj = {
          'url':'v3/products',
          'body': deliveractData,
        };
        return this.api.getWithoutPostToGet(deliveractObj);
      }
    }
    else{
    const obj = {
      'url': 'get_products_for_category',
      'body': {
          ...data, // Spread operator to include existing properties from `data`
          menu_id // Add the new `menu_id` property
        }
    };
    // if (this.sessionService.homeViewTheme() && !data.oftenBoughtArray) {
    //   obj.url = 'get_all_products_under_category'
    // }
    return this.api.post(obj);
    }
  }
  nLevelCategory(data) {
    // const headers = new Headers();
    const obj = {
      'url': 'catalogue/getParentCategories',
      'body': data || {},
      // 'headers': headers
    };
    return this.api.post(obj);
  }
  public convertStringToBreakHTML(string: string){
    if (string) {
      let str = string.split('&lt;').join('<');
      let str2 = str.split('&gt;').join('>');
      return str2.split('\\n').join('<br>')
    }
    return string;
  }

  getAllPages(data) {
    // const headers = new Headers();
    const obj = {
      'url': 'userPages/get',
      'body': data,
      // 'headers': headers
    };
    return this.api.post(obj);
  }

  getSingleRestaturant(data) {
    if (this.sessionService.isPlatformServer()) {
      data.source = 0;
    }
    const obj = {
      'url': 'marketplace_get_city_storefronts_single_v2',
      'body': {...data,source:0},
      // 'headers': headers
    };
    return this.api.get(obj);
  }

  cartDataChanged(){
    this.cartDataChange.emit(true);
  }

  // THIS API IS USED IN BREWSAGE THEME TO GET THE FILTER PRODUCTS WHEN YOU APPLY FILTERS
  // getFilteredData(data) {
  //   data['theme_version'] = 1;
  //   const obj = {
  //     'url': 'product/getAll',
  //     'body': data || {},
  //   };
  //   return this.api.post(obj);
  // }
  
  getAddonsDetails(data) {
  const deliveractData = {
    'offset': 0,
    'limit': 1,
    'marketplace_user_id': this.sessionService.get('config').marketplace_user_id,
    'user_id': data.user_id,
  }

  if (this.sessionService.get('appData')) {
    deliveractData['access_token'] = this.sessionService.get('appData').vendor_details.app_access_token;
  }
  
  const obj = {
    'url':'v3/menu/product/' + data.product_id,
    'body': deliveractData,
  };

  return this.api.getWithoutPostToGet(obj);
}
getActiveMenuList(data: any): Observable<any>{
  const obj = {
    'url':'menu/active',
    'body': data,
  };
  return this.api.getActiveMenuList(obj);
}
getProductTemplate(data: any): Observable<any>{
  const obj = {
    'url':'product-details/template/get',
    'body': data,
  };
  return this.api.postWithoutDOmain(obj);
}

moduleWiseVersion(gettingVersion, data?, merchantId?) {
  const body = {
      user_id : merchantId,
      module_name: data?.module_name,
  };

  const params = new HttpParams({ encoder: new HttpParamEncoder(), fromObject: body });
  const obj = {
    url: 'v1/module',
    params
  };
  return this.api.getWithEncodedParams(obj.url, gettingVersion? obj.params : '');
}

}
